import * as React from 'react';
import Dropdown, { DropdownOption } from './Dropdown';
import getStates from '../utils/getStates';
import { HatType } from './Hat';

interface StateProps {
  excludeNonConus?: boolean;
  excludeNonContiguousStates?: boolean;
  excludeStates?: string[];
  value?: string;
  theme?: 'night' | 'day';
  hat?: HatType[];
  label: string;
  maxHeight?: string;
  noOptionSelectedText?: string;
  name: string;
  id: string;
  required?: boolean;
  displayFullName?: boolean;
  readOnly?: boolean;
  focus?: boolean;
  hasError?: boolean;
  errors?: any;
  onChange?: (selectedOption: DropdownOption) => void;
  onComplete?: Function;
  onError?: Function;
  onBlur?: Function;
  onClick?: Function;
  expanded?: boolean;
  disabled?: boolean;
}

export default function State(props: StateProps) {
  const options = getStates(
    props.displayFullName,
    props.excludeNonConus,
    props.excludeNonContiguousStates,
    props.excludeStates
  );
  return (
    <>
      <Dropdown
        label={props.label}
        name={props.name}
        id={props.id}
        maxHeight={props.maxHeight}
        options={options}
        value={props.value}
        theme={props.theme}
        noOptionSelectedText={props.noOptionSelectedText}
        required={props.required}
        readOnly={props.readOnly}
        focus={props.focus}
        hasError={props.hasError}
        errors={props.errors}
        hat={props.hat}
        onChange={props.onChange}
        onComplete={props.onComplete}
        onError={props.onError}
        onBlur={props.onBlur}
        onClick={props.onClick}
        expanded={props.expanded}
        disabled={props.disabled}
      />
    </>
  );
}
